import React from 'react'
import PropTypes from 'prop-types'
import { Panel } from '../../../common/Panel/Panel'
import { ImageThumbnail } from '../../../common/ImageThumbnail/ImageThumbnail'

import bloodPressureIcon from '../../../../resources/images/icons/bloodPressure.svg'
import bmiIcon from '../../../../resources/images/icons/bmi.svg'
import heightIcon from '../../../../resources/images/icons/height.svg'
import weightIcon from '../../../../resources/images/icons/weight.svg'
import cephalicPerimeter from '../../../../resources/images/icons/cephalicPerimeter.svg'
import questionMarkIcon from '../../../../resources/images/icons/questionMark.svg'

import {polyglot} from '../../../../index'

import './style.css'
import SectionTitle from '../../../common/SectionTitle/SectionTitle'
import ListItem from '../../../common/ListItem/ListItem'
import RichTextViewer from '../../../common/RichTextViewer/RichTextViewer'

function getImageForParameter (parameter) {
  switch (parameter) {
    case 'bloodPressure':
      return bloodPressureIcon
    case 'bmi':
      return bmiIcon
    case 'height':
      return heightIcon
    case 'weight':
      return weightIcon
    case 'cephalicPerimeter':
      return cephalicPerimeter
    default:
      return questionMarkIcon
  }
}

function getPanelType (consultationStatus) {
  if (consultationStatus === 'late') {
    return 'panel-danger'
  } else if (consultationStatus === 'onTime') {
    return 'panel-success'
  } else if (consultationStatus === 'additional') {
    return 'panel-info'
  } else {
    return 'panel-default'
  }
}

function valueIsAnalyzed (analyzed, value) {
  let result = false
  if (analyzed) {
    Object.keys(analyzed).forEach(key => {
      if (key === value) {
        if (typeof analyzed[key] === 'string') {
          result = analyzed[key] !== 'negative'
        } else if (typeof analyzed[key] === 'object') {
          result = analyzed[key][0] === 'analyzed'
        }
      }
    })
  }
  return result
}

function consultationItemsShouldHaveStatus (consultationStatus) {
  return consultationStatus === 'now' || consultationStatus === 'late' || consultationStatus === 'onTime'
}

const Consultation = (props) => {
  return <div>
    <Panel panelType={getPanelType(props.consultationStatus)} heading={props.title} rightHeader={props.rightField} defaultOpen={props.isOpen} disableCollapse={!props.openable}>
      <div>
        <div className='col-xs-12'>
          {Object.keys(props.healthParameters).map(key => {
            const parameter = props.healthParameters[key]
            return <div key={key} className='col-xs-6 col-sm-4 col-md-3 col-lg-2'>
              <ImageThumbnail key={key} image={getImageForParameter(parameter.name)} imageDescription={parameter.label}>
                <h4>{props.savedData && props.savedData.healthParameters && (props.savedData.healthParameters[parameter.name] || '-')}</h4>
              </ImageThumbnail>
            </div>
          })}
        </div>
        {
          props.examinedParameters ? <div className='col-xs-12 col-sm-6'>
            <SectionTitle title={polyglot.t('staticFields.consultation.examinedParameters.title')} size={'h5'} />
            <ul>
              {Object.keys(props.examinedParameters).map((key, index) => {
                const parameter = props.examinedParameters[key]
                return <ListItem
                  commentary={props.savedData && props.savedData.examinedParameters && props.savedData['examinedParameters'][parameter.name]}
                  status={consultationItemsShouldHaveStatus(props.consultationStatus) ? valueIsAnalyzed(props.savedData && props.savedData['examinedParameters'], parameter.name) ? 'success' : 'danger' : null}
                  key={index}>{polyglot.t(parameter.label)}</ListItem>
              })}
            </ul>
          </div> : null
        }
        {
          props.conversationTopics ? <div className='col-xs-12 col-sm-6'>
            <SectionTitle title={polyglot.t('staticFields.consultation.conversationTopics.title')} size={'h5'} />
            <ul>
              {Object.keys(props.conversationTopics).map((key, index) => {
                const topic = props.conversationTopics[key]
                return <ListItem
                  status={consultationItemsShouldHaveStatus(props.consultationStatus) ? valueIsAnalyzed(props.savedData && props.savedData.conversationTopics && props.savedData['conversationTopics'], topic.name) ? 'success' : 'danger' : null}
                  key={index}>{polyglot.t(topic.label)}</ListItem>
              })}
            </ul>
          </div> : null
        }
        {
          props.savedData && props.savedData.observations ? <div className='col-xs-12'>
            <SectionTitle title={polyglot.t('staticFields.consultation.observations.title')} size={'h5'} />
            <RichTextViewer content={props.savedData.observations.observations} />
          </div> : null
        }
      </div>
    </Panel>
  </div>
}

export default Consultation

Consultation.defaultProps = {
  isOpen: false,
  openable: true
}

Consultation.propTypes = {
  rightField: PropTypes.object,
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  openable: PropTypes.bool,
  consultationStatus: PropTypes.oneOf(['onTime', 'late', 'future', 'now', 'additional']),
  healthParameters: PropTypes.array,
  examinedParameters: PropTypes.array,
  conversationTopics: PropTypes.array,
  savedData: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/general/Consultations/Consultation/Consultation.js